"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var footer_1 = __importDefault(require("../../data/footer"));
var DetailFooter = function (props) {
    var id = props.id, linkBack = props.linkBack, deletePromise = props.deletePromise, displayType = props.displayType, onBack = props.onBack, onDelete = props.onDelete, message = props.message;
    var showDelete = displayType && typeof displayType["delete"] !== 'undefined'
        ? displayType["delete"]
        : (displayType === null || displayType === void 0 ? void 0 : displayType.editType) !== 'view';
    return (react_1["default"].createElement(footer_1["default"], { showDelete: showDelete, link: linkBack, promise: deletePromise, id: id, onBack: onBack, onDelete: onDelete, message: message }));
};
exports["default"] = DetailFooter;
